export enum PaymentsStepId {
  MANAGER_OUTSTANDING = 'mgr.outstanding',
  TENANT_PAY = 'tenant.pay',
  MANAGER_CLEARED = 'mgr.cleared',
  MANAGER_TRANSACTIONS = 'mgr.transactions',
}

export enum PaymentsSubsceneId {
  INVOICE = 'invoice',
  PREVIEW = 'preview',
  LIST = 'list',
  REVIEW = 'review',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  CLEARED = 'cleared',
  PAYMENT = 'payment',
  TRANSACTIONS = 'transactions',
}
